
export const reportbasic = {

  report: {
    service: {
      name: 'report',
      title: 'Reports',
    }
  },

};
